export function addLocationCollection(collection, locationSummary) {
  if (!collection) {
    return null;
  }

  if (!locationSummary || Object.keys(locationSummary).length === 0) {
    return collection;
  }

  let updatedCollection = collection.filter((item) => item.name !== 'locations');

  updatedCollection.unshift(locationSummary);

  return updatedCollection;
}
